const data = [
  {
    name: "Painel",
    path: null,
    children: [
      { name: "Início", icon: "mdi-view-dashboard-outline", route: "/home", path: null },
    ],
  },
  {
    name: "Gestão",
    path: "Manager",
    children: [
      { name: "Acessos da Devedora", icon: "mdi-account-key-outline", route: "/acessos-devedora", path: "ClientUser" },
      { name: "Administradores", icon: "mdi-account-supervisor-circle-outline", route: "/admins", path: "Admin" },
      { name: "Casos", icon: "mdi-account-file-outline", route: "/casos", path: "Client" },
      { name: "Colaboradores", icon: "mdi-account-multiple-outline", route: "/colaboradores", path: "Employee" },
      { name: "Comarcas", icon: "mdi-map-marker-distance", route: "/comarcas", path: "District" },
      // { name: "Credenciamento", icon: "mdi-account-eye-outline", route: "/credenciamentos", path: "Accreditation" },
      { name: "Credores", icon: "mdi-account-group-outline", route: "/credores", path: "User" },
      { name: "Documentos", icon: "mdi-file-outline", route: "/documentos", path: "Document" },
      { name: "Hab/Div", icon: "mdi-sync-alert", route: "/divergencias", path: "Event" },
      { name: "Importação QGC", icon: "mdi-file-upload-outline", route: "/lista-credores", path: "Creditors" },
      { name: "QGC", icon: "mdi-account-details-outline", route: "/qgc", path: "Creditors" },
      { name: "Textos Automáticos (RVC)", icon: "mdi-text-box-outline", route: "/textos-automaticos", path: "DynamicText" },      
      
    ],
  },
  {
    name: "Site",
    path: "Site",
    children: [
      { name: "Assembleias", icon: "mdi-video-outline", route: "/agcs", path: "GeneralMeeting" },
      { name: "Dúvidas", icon: "mdi-account-question-outline", route: "/faqs", path: "Faq" },
      { name: "Leilões", icon: "mdi-gavel", route: "/leiloes", path: "Auction" },
      { name: "Modelos de Documentos", icon: "mdi-file-download-outline", route: "/modelos-documentos", path: "DocumentTemplate" },
      { name: "Processos Mais Consultados", icon: "mdi-text-box-search-outline", route: "/processos-mais-consultados", path: "MostConsulted" },
      { name: "Redes Sociais", icon: "mdi-share-variant-outline", route: "/redes-sociais", path: "SiteSettings" },
      { name: "Solicitações do Site", icon: "mdi-inbox-arrow-down-outline", route: "/solicitacoes-site", path: "SiteRequest" },
      { name: "Textos Dinâmicos", icon: "mdi-file-chart-outline", route: "/textos-dinamicos", path: "DynamicInfo" },    
      // { name: "Atos Processuais", icon: "mdi-file-document-edit-outline", route: "/vehicles" },
      // { name: "Habilitações e Divergências", icon: "mdi-text-box-check-outline", route: "/vehicles" },
    ],
  },
  {
    name: "Blog",
    path: "Site",
    children: [
      // Sem tela de categorias no router; reativar quando existir.
      // { name: "Categorias", icon: "mdi-shape-outline", route: "/blog/categorias", path: "BlogCategory" },
      { name: "Postagens", icon: "mdi-post-outline", route: "/blog/posts", path: "Blog" },
    ],
  },
];

export default [...data];
